
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { SortDescriptor } from '@progress/kendo-data-query';
import { isNullOrUndefined } from 'util';
import { CLPUser } from '../../../../models/clpuser.model';
import { RoleFeaturePermissions } from '../../../../models/roleContainer.model';
import { StorageSummary, StorageSummaryResponse } from '../../../../models/storage.model';
import { NotificationService } from '../../../../services/notification.service';
import { GridConfigurationService } from '../../../../services/shared/gridConfiguration.service';
import { LocalService } from '../../../../services/shared/local.service';
import { UtilityService } from '../../../../services/shared/utility.service';
import { StorageService } from '../../../../services/storage.service';
import { process } from '@progress/kendo-data-query';
import { DataBindingDirective } from '@progress/kendo-angular-grid';
import { eUserRole } from '../../../../models/enum.model';
import { Router } from '@angular/router';
import { GlobalService } from '../../../../services/global.service';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

@Component({
    selector: 'account-storage-summary',
    templateUrl: './account-storage-summary.component.html',
    styleUrls: ['./account-storage-summary.component.css'],
    providers: [GridConfigurationService]
})

export class AccountStorageSummaryComponent implements OnInit {
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    storageSummarySource: MatTableDataSource<any>;
    storageSummaryDisplayColumns: string[];
    @Input() encryptedUser: string;
    @Input() user: CLPUser;
    @Input() roleFeaturePermissions: RoleFeaturePermissions;
    showSpinner: boolean = false;
    storageSum: boolean = false;
    storageSummary: StorageSummary[] = [];
    public initStorageSummary: StorageSummary[] = [];
    totalSpaceUsed: number;
    totalCapacity: number;
    columns = [
        { field: 'firstName', title: 'User', width: '10' },
        { field: 'spaceUsed', title: 'Space Used (in MBs)', width: '500' },
    ];
    reorderColumnName: string = 'firstName,spaceUsed';
    columnWidth: string = 'firstName:10,spaceUsed:50';
    arrColumnWidth: any[] = ['firstName:10,spaceUsed:50'];

    pageSize: number = 10;
    accountStorageResponse: StorageSummaryResponse;
    @ViewChild(DataBindingDirective) dataBinding: DataBindingDirective;
    mobileColumnNames: string[];
    constructor(private _storageService: StorageService,
        private _localService: LocalService,
        private _utilityService: UtilityService,
        public _notifyService: NotificationService,
        public _globalService: GlobalService,
        private _router: Router,
        public _gridCnfgService: GridConfigurationService,) {
        this._localService.isMenu = true;


    }

    ngOnInit(): void {

        this._globalService.getToken((token) => {
            if (token) {
                this.encryptedUser = token;
                if (this.user) {
                    if (this.user?.userRole <= eUserRole.Administrator) {
                        if (this.roleFeaturePermissions?.view == false)
                            this._router.navigate(['/unauthorized'], { state: { isMenu: true } });
                        else {
                            //Kendo grid load call stopped.
                            //this.getGridConfiguration();
                            this.getStorageSummary();
                        }
                    }
                    else {
                        //Kendo grid load call stopped.
                        //this.getGridConfiguration();
                        this.getStorageSummary();
                    }
                }
                else
                    this._router.navigate(['/login']);
            }
            else
                this._router.navigate(['/login']);
        });
    }

    //getGridConfiguration() {
    //    this._gridCnfgService.user = this.user;
    //    this._gridCnfgService.columns = this.columns;
    //    this._gridCnfgService.reorderColumnName = this.reorderColumnName;
    //    this._gridCnfgService.columnWidth = this.columnWidth;
    //    this._gridCnfgService.arrColumnWidth = this.arrColumnWidth;
    //    this._gridCnfgService.getGridColumnsConfiguration(this.user.cLPUserID, 'account_storage_grid').subscribe((value) => this._gridCnfgService.createGetGridColumnsConfiguration('account_storage_grid').subscribe((value) => { }));
    //}

    //resetGridSetting() {
    //    this._gridCnfgService.deleteColumnsConfiguration(this.user.cLPUserID, 'account_storage_grid').subscribe((value) => this.getGridConfiguration());

    //}

    getStorageSummary() {
        this.showSpinner = true;
        this._storageService.getStorageList(this.encryptedUser, this.user.cLPCompanyID)
            .then(async (result: StorageSummaryResponse) => {
                if (result) {
                    this.accountStorageResponse = UtilityService.clone(result);
                    this.storageSummary = this.accountStorageResponse.storageSummary;
                    this.initStorageSummary = this.accountStorageResponse.storageSummary;
                    this.totalSpaceUsed = this.accountStorageResponse.companySpaceUsed;
                    this.totalSpaceUsed = (this.totalSpaceUsed / 1024) / 1024;
                    //if (!isNullOrUndefined(this._gridCnfgService)) {
                    //    this._gridCnfgService.iterateConfigGrid(this.accountStorageResponse, "account_storage_grid");
                    //    this.mobileColumnNames = this._gridCnfgService.getResponsiveGridColums('account_storage_grid');
                    //}
                    if (isNaN(this.totalSpaceUsed))
                        this.totalSpaceUsed = 0;
                    else {
                        var totalSpace = Number(this.totalSpaceUsed).toFixed(1);
                        this.totalSpaceUsed = +totalSpace;
                    }

                    this.totalCapacity = this.accountStorageResponse.totalStorageCapacity;
                    this.totalCapacity = (this.totalCapacity / 1024) / 1024;
                    if (isNaN(this.totalCapacity))
                        this.totalCapacity = 0;
                    else {
                        var spaceCapacity = Number(this.totalCapacity).toFixed(1);
                        this.totalCapacity = +spaceCapacity;
                    }

                    this.setGrid(this.storageSummary);
                    this.showSpinner = false;
                }
                else
                    this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("account-storage-summary.getMailMergeTemplateList", err.message, null, 'cLPCompanyID ' + this.user.cLPCompanyID);
                this.showSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });
    }

    onStorageSummaryFilter(inputValue: string): void {
        //this.storageSummary = process(this.initStorageSummary, {
        //    filter: {
        //        logic: "or",
        //        filters: [
        //            { field: 'firstName', operator: 'contains', value: inputValue },
        //            { field: 'lastName', operator: 'contains', value: inputValue },
        //            { field: 'spaceUsed', operator: 'contains', value: inputValue }
        //        ],
        //    }
        //}).data;
        //this.dataBinding.skip = 0;

        inputValue = inputValue.trim().toLowerCase();

        if (this.storageSummarySource) {
            this.storageSummarySource.filterPredicate = (data: any, filter: string) => {
                return Object.keys(data).some((key) => {
                    return data[key]?.toString().toLowerCase().includes(filter);
                });
            };

            this.storageSummarySource.filter = inputValue;
        }
    }

    setGrid(list) {
        this.storageSummaryDisplayColumns = this.columns.map(c => c.field);
        this.storageSummarySource = new MatTableDataSource(list);
        this.addTimeout(() => {
            this.storageSummarySource.paginator = this.paginator;
            if (this.paginator) {
                this.paginator.pageSize = this._localService.getPageSize('account_storage_grid') ? this._localService.getPageSize('account_storage_grid'): 50;
            }
            if (this.sort) {
                this.storageSummarySource.sort = this.sort;
                const sortState: Sort = this._localService.getSortState('account_storage_grid');
                this.sort.active = sortState?.active;
                this.sort.direction = sortState?.direction;
                this.sort.sortChange.emit(sortState);
            }
        }, 500)
    }

    getSerialNumber(index: number): number {
        return index + 1 + (this.paginator?.pageIndex || 0) * (this.paginator?.pageSize || 5);
    }

    private timeouts = new Set<ReturnType<typeof setTimeout>>();
    addTimeout(callback, timeout) {
        const id = setTimeout(() => {
            if (callback) {
                callback();
            }
            this.timeouts.delete(id);
        }, timeout);
        this.timeouts.add(id);
    }

    ngOnDestroy() {
        this.timeouts.forEach(id => clearTimeout(id));
        this.timeouts.clear();
    }
}
